import { Typography, TypographyProps } from "@mui/material";
import React from "react";

import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import WarningIcon from "@mui/icons-material/Warning";
import { useTranslation } from "react-i18next";

export enum AssetSelectStatus {
  NotSelected,
  Ok,
  MissingAsset,
}

export type TableCellPackageBundleStatusProps = {
  status: AssetSelectStatus;
};

const TableCellPackageBundleStatus: React.FC<TableCellPackageBundleStatusProps> = (props) => {
  const { t } = useTranslation();
  let color: TypographyProps["color"] = "warning.main";
  let icon: React.ReactNode = <WarningIcon fontSize="small" sx={{ mr: 0.5 }} />;
  let label = t("menu:item.missingAssets");

  switch (props.status) {
    case AssetSelectStatus.Ok:
      color = "success.main";
      icon = <CheckCircleOutlinedIcon fontSize="small" sx={{ mr: 0.5 }} />;
      label = t("common:valid");
      break;
    case AssetSelectStatus.NotSelected:
      label = t("table:cellLabel.notSelected");
      break;
  }

  return (
    <Typography display="inline-flex" alignItems="center" variant="body1" color={color}>
      {icon} {label}
    </Typography>
  );
};

export default TableCellPackageBundleStatus;
